"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RHFInputFields = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var freeText_1 = require("@domain/freeText");
var RHFInput_1 = require("@components/base/RHFInput");
/**
 * base配下にあるReactHookForm用のinput Fieldの出し分けコンポーネント
 */
var RHFInputFields = function (props) {
    switch (props.itemType) {
        case freeText_1.FreeTextItemType.TEXT:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFTextField, __assign({}, props));
        case freeText_1.FreeTextItemType.TEXTAREA:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFTextArea, __assign({}, props));
        case freeText_1.FreeTextItemType.NUMBER:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFNumberField, __assign({}, props));
        case freeText_1.FreeTextItemType.DATE_TIME:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFDateTimeField, __assign({}, props));
        case freeText_1.FreeTextItemType.DATE:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFDateField, __assign({}, props));
        case freeText_1.FreeTextItemType.TEL:
            return (0, jsx_runtime_1.jsx)(RHFInput_1.RHFTelField, __assign({}, props));
        default:
            return null;
    }
};
exports.RHFInputFields = RHFInputFields;
